import { render, staticRenderFns } from "./MoreRuleButtons.vue?vue&type=template&id=41221787&"
import script from "./MoreRuleButtons.vue?vue&type=script&lang=js&"
export * from "./MoreRuleButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports